exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linkReadMoreStyle {\n  font-weight: bold;\n  cursor: pointer; }\n\n.wrapperLink {\n  margin-top: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%; }\n\n.containerLink {\n  max-width: 50%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/shareholder/shareholder-google/shareholder-google.component.scss
// module id = ../../../../../src/app/securities-level/shareholder/shareholder-google/shareholder-google.component.scss
// module chunks = main